export default "__VITE_ASSET__32d1432a__"